module.exports = __webpack_public_path__ + "static/media/RP-A_S_Jacquard_Meda_Ind.Blue_Peri.e48fc109.png";